import MTextArea from './MTextArea.vue';

MTextArea.install = (app) => {
  app.component('MTextArea', MTextArea);
};

export { MTextArea };
